export default __webpack_public_path__ + "static/media/iphone-mockup.3f11ece3.png";